/* ════════════════════════════════════════════════════════════════════════════
   st-app.js — /speaker-test: прибор «проверка наушников и динамиков».

   Пять режимов на одном экране (разбор и замеры — docs/why/speaker-test.md):
     lr   — лево / право: три кнопки-канала, «Быстрая проверка» (левый → правый →
            оба), «По очереди», вердикт «что вы услышали»;
     bal  — баланс: человек ставит звук посередине, прибор называет разницу в дБ,
            а после перестановки наушников — наушник это или ухо (st-core.js);
     surr — 5.1 / 7.1 по физическим каналам (surround-engine.js), голосом;
     freq — свипы с отметкой «здесь пропал звук», отдельные частоты, генератор,
            поиск дребезга;
     fix  — «Нет звука?»: проверки по порядку, микрофон слушает динамики,
            поиск выхода, через который звук правда идёт.

   Звук. Один граф на контекст: источник → маршрут (ChannelMerger с усилением
   на каждый канал) → громкость → выход; от громкости — разветвитель каналов в
   два анализатора для индикаторов. Маршрут с явными коэффициентами, а не
   StereoPanner: только так «Оба» с перевёрнутой фазой и баланс в децибелах —
   одно и то же точное правило (pairGains / balanceGains в st-core.js).

   Голос — короткие MP3 этой локали (scripts/build-speaker-test-voice.php), все
   выровнены по громкости: «Левый» и «Правый» обязаны звучать одинаково, иначе
   прибор сам сочинит «один наушник тише».

   Нажатие. Контекст будится ВНУТРИ нажатия (__liveAudioCtxReady зовёт resume()
   синхронно — WebKit иначе не даёт звука). Беззвучный режим iPhone — не здесь:
   аудиосессией страницы владеет ios-audio-unmute.js (ставит 'playback' на
   первом AudioContext, 'auto' на время записи микрофоном, выбор человека — в
   «Настройках» сайдбара).

   Файлы для флешки (Премиум) — st-pack.js, грузится по нажатию «Подготовить».
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
'use strict';

var CFG = window.ST_CFG || {};
var T = CFG.t || {};
var SLUG = 'speaker-test';
var EA_KEY = 'speaker-test';
var root = document.getElementById('stConsole');
var C = window.SpeakerTestCore;
var EA = window.__earlyAction;
if (!root) return;
if (!C) { try { if (window.__earlyAction) window.__earlyAction.claim(EA_KEY); } catch (e) { } return; }

/* ── мелочи ──────────────────────────────────────────────────────────────── */
function $(id) { return document.getElementById(id); }
function qa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
function noop() { }
function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
function fill(tpl, v) { return String(tpl || '').replace(/:([a-z_]+)/g, function (m, k) { return v && v[k] != null ? v[k] : m; }); }
function feat(f, p) { try { if (window.__aeFeature) window.__aeFeature(f, p || {}); } catch (e) { } }
function funnel(st, p) { try { if (window.__aeFunnel) window.__aeFunnel(st, p || {}); } catch (e) { } }
function say(msg) { var a = $('stAnnounce'); if (a) a.textContent = msg || ''; }
function setText(el, s) { if (!el) return; if (window.__setText) return window.__setText(el, s); if (el.textContent !== s) el.textContent = s; }
function pxWrite(e, p, v, u) { if (window.__perPixel) return window.__perPixel(e, p, v, u); e.style[p] = v + (u || '%'); }
var LOCALE = (function () { try { return (window.__intlLocale && window.__intlLocale()) || CFG.locale || 'en'; } catch (e) { return 'en'; } })();
var NF1 = (function () { try { return new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 1 }); } catch (e) { return { format: function (v) { return String(Math.round(v * 10) / 10); } }; } })();
function fmtDb(v) { return NF1.format(Math.abs(v)); }
function fmtHz(hz) { var f = C.fmtFreq(hz, LOCALE); return f.v + ' ' + (f.k ? T.unit_khz : T.unit_hz); }
function fmtHzHtml(hz) { var f = C.fmtFreq(hz, LOCALE); return esc(f.v) + ' <small>' + esc(f.k ? T.unit_khz : T.unit_hz) + '</small>'; }
function osKey() {
    var ua = navigator.userAgent || '';
    if (/Android/i.test(ua)) return 'android';
    if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'ios';
    if (/Windows/i.test(ua)) return 'win';
    if (/Mac OS X|Macintosh/i.test(ua)) return 'mac';
    return '';
}
function list(items) { return '<ol>' + items.filter(Boolean).map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ol>'; }

/* ── состояние ───────────────────────────────────────────────────────────── */
var S = {
    mode: 'lr',
    lr: { snd: null, invert: false, heardL: false, heardR: false },
    bal: { snd: 'pink', b: 0, moved: false, swapped: false, b1: null },
    surr: { cfg: '51', snd: null },
    freq: { sub: 'sweep', sweep: 'high', marks: [], wave: 'sine', rattleMarks: [] }
};
var cur = null;              // то, что звучит сейчас: {kind, stop(), ...}
var completed = false;       // tool_complete — один раз, на первый настоящий звук

/* ── контекст и граф ─────────────────────────────────────────────────────── */
var ctx = null, master = null, anL = null, anR = null, anS = null, surrBus = null;
var selectedDeviceId = '';
var bufDL = null, bufDR = null, bufS = null;

function makeCtx() {
    var AC = window.AudioContext || window.webkitAudioContext;
    try { return new AC({ latencyHint: 'interactive' }); } catch (e) { return new AC(); }
}
function buildGraph() {
    master = ctx.createGain();
    master.gain.value = volume();
    master.channelCount = 2; master.channelCountMode = 'explicit'; master.channelInterpretation = 'speakers';
    master.connect(ctx.destination);
    try {
        var sp = ctx.createChannelSplitter(2);
        master.connect(sp);
        anL = ctx.createAnalyser(); anR = ctx.createAnalyser();
        anL.fftSize = anR.fftSize = 1024;
        sp.connect(anL, 0); sp.connect(anR, 1);
        anS = ctx.createAnalyser(); anS.fftSize = 2048; anS.smoothingTimeConstant = 0.7;
        master.connect(anS);
        bufDL = new Float32Array(anL.fftSize); bufDR = new Float32Array(anR.fftSize); bufS = new Uint8Array(anS.frequencyBinCount);
    } catch (e) { anL = anR = anS = null; }
    surrBus = null;
}
function adopt(c) {
    if (!c) return;
    if (c !== ctx || !master || master.context !== c) {
        ctx = c;
        buildGraph();
        if (selectedDeviceId && ctx.setSinkId) ctx.setSinkId(selectedDeviceId).catch(noop);
        hookCtx(ctx);
        outLabel();
    }
}
/* Синхронно: «есть ли контекст» — для подготовки на первом жесте и для
   сведений о выходе. Звука не обещает. */
function peekCtx() {
    try {
        var c = window.__liveAudioCtx ? window.__liveAudioCtx(ctx, makeCtx) : (ctx || makeCtx());
        adopt(c);
    } catch (e) { }
    return ctx;
}
/* Для нажатия: контекст, который ИГРАЕТ. Зовётся первой строкой обработчика. */
function ready() {
    var p;
    try {
        p = window.__liveAudioCtxReady ? window.__liveAudioCtxReady(ctx, makeCtx)
            : (function () { var c = ctx || makeCtx(); var r = c.resume ? c.resume() : null; return Promise.resolve(r).then(function () { return c; }); })();
    } catch (e) { return Promise.reject(e); }
    return Promise.resolve(p).then(function (c) { adopt(c); return c; });
}
function hookCtx(c) {
    if (!c || c.__stHooked) return;
    c.__stHooked = true;
    try {
        c.addEventListener('statechange', function () {
            if (c !== ctx) return;
            if (c.state === 'interrupted' || (c.state === 'suspended' && cur)) {
                pill('wait', T.pill_paused);
                status(T.interrupted);
            } else if (c.state === 'running' && cur) {
                pill('run', T.pill_playing);
            }
        });
    } catch (e) { }
}
function audioFail(e, where) {
    stopAll();
    if (!(e && e.__userNotified) && window.__handleError) {
        try { window.__handleError(e, where || 'st_audio_start', { say: T.no_web_audio }); } catch (x) { }
    }
    feat('st_audio_fail', { err: (e && e.name) || 'error', at: where || '' });
}
function markComplete() {
    if (completed) return;
    completed = true;
    try { if (window.__aeToolComplete) window.__aeToolComplete(); } catch (e) { }
}

/* Стратегия «C» (замер 30.07, docs/why/speaker-test.md): первый жест на странице
   открывает устройство вывода молча — первое «Левый» звучит через ~20 мс, а не
   через секунду. Посетитель, ничего не нажавший, не создаёт ничего. */
(function warm() {
    var evs = ['pointerdown', 'touchend', 'keydown'];
    function go() {
        evs.forEach(function (e) { document.removeEventListener(e, go, true); });
        try { peekCtx(); if (ctx && ctx.state === 'suspended') ctx.resume().catch(noop); } catch (e) { }
    }
    evs.forEach(function (e) { document.addEventListener(e, go, true); });
})();

/* ── громкость ───────────────────────────────────────────────────────────── */
var $vol = $('stVol'), $volVal = $('stVolVal'), $volWarn = $('stVolWarn');
function volume() {
    var v = parseInt($vol && $vol.value, 10);
    return isFinite(v) ? Math.max(0, Math.min(100, v)) / 100 : 0.5;
}
/* Громкость прибора помнится между визитами: в телеметрии она — первое, что
   отличает «устройство молчит» от «ползунок у нуля». */
function volPct() { return Math.round(volume() * 100); }
function paintRange(r) {
    var min = +r.min, max = +r.max, v = +r.value;
    if (!isFinite(v) || max === min) return;
    r.style.setProperty('--st-fill', ((v - min) / (max - min) * 100) + '%');
}
function onVol() {
    var v = parseInt($vol.value, 10);
    if (!isFinite(v)) return;          // пустое значение посреди жеста — не кормить NaN в AudioParam
    setText($volVal, v + '%');
    if ($volWarn) $volWarn.hidden = v <= 70;
    paintRange($vol);
    if (master && ctx) try { master.gain.setTargetAtTime(volume(), ctx.currentTime, 0.02); } catch (e) { }
    if (surrBus && ctx) try { surrBus.gain.setTargetAtTime(volume(), ctx.currentTime, 0.02); } catch (e) { }
}
if ($vol) {
    /* Новый ключ: громкость прежнего тула была в другой шкале (тон на полной
       амплитуде), её 25 % здесь звучали бы на 9 дБ тише и читались как «нет звука». */
    try { if (window.__toolSettings) window.__toolSettings.bind(SLUG, $vol, 'volume_v2', '50'); } catch (e) { }
    $vol.addEventListener('input', onVol);
    onVol();
}

/* ── источники ───────────────────────────────────────────────────────────── */
var NOISE = {};
function noiseBuf(kind) {
    if (NOISE[kind] && NOISE[kind].c === ctx) return NOISE[kind].b;
    var sr = ctx.sampleRate, len = Math.floor(sr * 4), fade = Math.floor(sr * 0.05);
    var buf = ctx.createBuffer(1, len + fade, sr), d = buf.getChannelData(0);
    var b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0, br = 0, i;
    for (i = 0; i < d.length; i++) {
        var w = Math.random() * 2 - 1;
        if (kind === 'pink') {
            b0 = 0.99886 * b0 + w * 0.0555179; b1 = 0.99332 * b1 + w * 0.0750759; b2 = 0.96900 * b2 + w * 0.1538520;
            b3 = 0.86650 * b3 + w * 0.3104856; b4 = 0.55000 * b4 + w * 0.5329522; b5 = -0.7616 * b5 - w * 0.0168980;
            d[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * 0.5362; b6 = w * 0.115926;
        } else if (kind === 'brown') {
            br = (br + 0.02 * w) / 1.02; d[i] = br;
        } else d[i] = w;
    }
    /* Шов петли: хвост вплавляется в начало, иначе коричневый шум щёлкает
       на каждом круге. */
    for (i = 0; i < fade; i++) { var k = i / fade; d[i] = d[i] * k + d[len + i] * (1 - k); }
    var out = ctx.createBuffer(1, len, sr), o = out.getChannelData(0), ss = 0;
    for (i = 0; i < len; i++) { o[i] = d[i]; ss += d[i] * d[i]; }
    /* Все шумы — одной громкости (RMS ≈ −15 dBFS): переключение белый →
       коричневый не должно звучать как «стало тише». */
    var g = 0.178 / Math.max(1e-9, Math.sqrt(ss / len));
    for (i = 0; i < len; i++) o[i] = Math.max(-0.99, Math.min(0.99, o[i] * g));
    NOISE[kind] = { c: ctx, b: out };
    return out;
}
var TONE_AMP = 0.35;          // синус: RMS ≈ −12 dBFS при громкости 100 %
function osc(freq, type) {
    var o = ctx.createOscillator();
    o.type = type || 'sine';
    o.frequency.value = isFinite(freq) ? freq : 440;
    return o;
}
/* Непрерывный источник в оба входа маршрута. Возвращает {nodes, stop, osc?}. */
function continuous(snd, route) {
    var env = ctx.createGain(), t = ctx.currentTime, nodes = [env], src, o = null;
    env.gain.setValueAtTime(0, t);
    env.gain.linearRampToValueAtTime(1, t + 0.04);
    if (/^t\d|^t1k$/.test(snd) || snd === 'bass') {
        var hz = snd === 't1k' ? 1000 : snd === 'bass' ? 60 : parseInt(snd.slice(1), 10);
        o = osc(hz); src = ctx.createGain(); src.gain.value = TONE_AMP * (snd === 'bass' ? 1.4 : 1);
        o.connect(src); o.start(); nodes.push(o, src);
    } else if (snd === 'sweep') {
        o = osc(20); src = ctx.createGain(); src.gain.value = TONE_AMP;
        /* По кругу, а не один раз: одиночный проход замирал на 20 кГц, которых не
           слышно, — плитка горела «звучит», а звука уже не было. Круги — на час
           вперёд; остановка снимает их вместе с осциллятором. */
        for (var k = 0; k < 450; k++) {
            o.frequency.setValueAtTime(20, t + k * 8);
            o.frequency.exponentialRampToValueAtTime(20000, t + (k + 1) * 8);
        }
        o.connect(src); o.start(); nodes.push(o, src);
    } else {
        var b = ctx.createBufferSource(); b.buffer = noiseBuf(snd === 'white' || snd === 'brown' ? snd : 'pink'); b.loop = true;
        src = b; b.start(); nodes.push(b);
    }
    src.connect(env);
    env.connect(route.gl); env.connect(route.gr);
    return {
        nodes: nodes, osc: o,
        stop: function () {
            var n = ctx.currentTime;
            try { env.gain.cancelScheduledValues(n); env.gain.setValueAtTime(env.gain.value, n); env.gain.linearRampToValueAtTime(0, n + 0.04); } catch (e) { }
            setTimeout(function () { nodes.forEach(function (x) { try { if (x.stop) x.stop(); } catch (e) { } try { x.disconnect(); } catch (e) { } }); }, 70);
        }
    };
}
function makeRoute() {
    var m = ctx.createChannelMerger(2), gl = ctx.createGain(), gr = ctx.createGain();
    gl.gain.value = 0; gr.gain.value = 0;
    gl.connect(m, 0, 0); gr.connect(m, 0, 1); m.connect(master);
    return {
        gl: gl, gr: gr, m: m,
        set: function (g, at, tau) {
            var t = at == null ? ctx.currentTime : at;
            tau = tau == null ? 0.008 : tau;
            try { gl.gain.setTargetAtTime(g.l, t, tau); gr.gain.setTargetAtTime(g.r, t, tau); } catch (e) { gl.gain.value = g.l; gr.gain.value = g.r; }
        },
        off: function () { setTimeout(function () { try { m.disconnect(); gl.disconnect(); gr.disconnect(); } catch (e) { } }, 120); }
    };
}

/* ── голос ───────────────────────────────────────────────────────────────── */
var VOICE_RAW = {}, VOICE = {};
function voiceUrl(key) { return CFG.voiceBase + key + '.mp3' + (CFG.voiceVer ? '?v=' + CFG.voiceVer : ''); }
function fetchVoice(key) {
    if (!CFG.voiceBase) return Promise.reject(new Error('no_voice'));
    if (!VOICE_RAW[key]) {
        VOICE_RAW[key] = fetch(voiceUrl(key), { credentials: 'same-origin' }).then(function (r) {
            if (!r.ok) throw new Error('voice_http_' + r.status);
            return r.arrayBuffer();
        });
        VOICE_RAW[key].catch(function () { delete VOICE_RAW[key]; });
    }
    return VOICE_RAW[key];
}
function decode(ab) {
    var copy = ab.slice(0);   // decodeAudioData отсоединяет буфер — сырой держим для нового контекста
    return new Promise(function (res, rej) {
        try {
            var p = ctx.decodeAudioData(copy, res, rej);
            if (p && p.then) p.then(res, rej);
        } catch (e) { rej(e); }
    });
}
function voice(keys) {
    return Promise.all(keys.map(function (k) {
        var hit = VOICE[k];
        if (hit && hit.c === ctx) return hit.b;
        return fetchVoice(k).then(decode).then(function (b) { VOICE[k] = { c: ctx, b: b }; return b; });
    })).then(function (bs) { var o = {}; keys.forEach(function (k, i) { o[k] = bs[i]; }); return o; });
}
function voiceFailed(e) {
    feat('st_voice_fail', { err: String((e && e.message) || e || '').slice(0, 40) });
    if (window.__toast) try { window.__toast(T.voice_fail, 'info'); } catch (x) { }
}
/* Подписи стерео — заранее, пока человек читает страницу: первое нажатие не
   ждёт сети. Только байты (≈ 10 КБ), расшифровка — при первом звуке. */
if (CFG.voiceBase) {
    var pre = function () { ['left', 'right', 'center'].forEach(function (k) { fetchVoice(k).catch(noop); }); };
    if (window.requestIdleCallback) requestIdleCallback(pre, { timeout: 4000 }); else setTimeout(pre, 1500);
}

/* ── индикаторы уровня ───────────────────────────────────────────────────── */
var meterEls = {
    L: root.querySelector('[data-meter="L"]'), R: root.querySelector('[data-meter="R"]'),
    CL: root.querySelector('[data-meter="CL"]'), CR: root.querySelector('[data-meter="CR"]')
};
var rings = { L: root.querySelector('.st-tile[data-ch="L"] .st-ring'), C: root.querySelector('.st-tile[data-ch="C"] .st-ring'), R: root.querySelector('.st-tile[data-ch="R"] .st-ring') };
var lastLv = {}, meterRaf = 0;
function rms(an, buf) {
    if (!an) return 0;
    if (an.getFloatTimeDomainData) an.getFloatTimeDomainData(buf);
    var s = 0; for (var i = 0; i < buf.length; i += 2) s += buf[i] * buf[i];
    return Math.sqrt(s / (buf.length / 2));
}
function lvl(r) { var db = 20 * Math.log10(r + 1e-9); return Math.max(0, Math.min(1, (db + 54) / 48)); }
function put(key, el, v, prop) {
    if (!el) return;
    if (lastLv[key] != null && Math.abs(lastLv[key] - v) < 0.012) return;
    lastLv[key] = v;
    if (prop === 'o') el.style.opacity = v.toFixed(3);
    else el.style.transform = 'scaleX(' + v.toFixed(3) + ')';
}
function meterFrame() {
    meterRaf = 0;
    if (!cur || (S.mode !== 'lr' && S.mode !== 'bal') || document.hidden) { meterZero(); return; }
    var l = lvl(rms(anL, bufDL)), r = lvl(rms(anR, bufDR));
    put('L', meterEls.L, l); put('R', meterEls.R, r); put('CL', meterEls.CL, l); put('CR', meterEls.CR, r);
    var ch = cur.ch;
    put('rL', rings.L, ch === 'L' ? l : 0, 'o');
    put('rR', rings.R, ch === 'R' ? r : 0, 'o');
    put('rC', rings.C, ch === 'C' ? Math.max(l, r) : 0, 'o');
    meterRaf = requestAnimationFrame(meterFrame);
}
function meterOn() { if (!meterRaf && anL) meterRaf = requestAnimationFrame(meterFrame); }
function meterZero() {
    ['L', 'R', 'CL', 'CR'].forEach(function (k) { put(k, meterEls[k], 0); });
    ['L', 'R', 'C'].forEach(function (k) { put('r' + k, rings[k], 0, 'o'); });
}

/* ── экран: пилюля, строка состояния, выход ──────────────────────────────── */
var $pill = $('stPill'), $sndLbl = $('stSndLbl'), $outLbl = $('stOutLbl');
function pill(state, txt) { if (!$pill) return; $pill.setAttribute('data-state', state); setText($pill, txt); }
/* Что звучит — в верхней строке экрана (там же в покое стоит выбранный звук). */
/* Пока грузится голос (первое нажатие на медленной сети): кнопка нажата,
   звук будет — человек это видит, а не жмёт ещё раз. */
function loading() { if (!cur) pill('wait', '…'); }
function status(txt) { if (!txt) { sndLabel(); return; } setText($sndLbl, txt); }
function outLabel() {
    if (!$outLbl) return;
    var n = 2;
    try { n = (ctx && ctx.destination.maxChannelCount) || 2; } catch (e) { }
    setText($outLbl, ctx ? fill(T.out_ch, { n: n }) : '');
    var sum = $('stSumOut');
    if (sum) setText(sum, deviceName() || T.device_default);
}
function deviceName() {
    var sel = $('stDeviceSelect');
    if (!sel || !sel.value) return '';
    var o = sel.options[sel.selectedIndex];
    return o ? o.textContent.replace(/^\S+\s/, '') : '';
}

/* ── общий стоп ──────────────────────────────────────────────────────────── */
var timers = [];
function later(fn, ms) { var id = setTimeout(fn, Math.max(0, ms)); timers.push(id); return id; }
function clearTimers() { timers.forEach(clearTimeout); timers = []; }
function resetDest() {
    try {
        if (ctx) { ctx.destination.channelCount = 2; ctx.destination.channelCountMode = 'explicit'; ctx.destination.channelInterpretation = 'speakers'; }
    } catch (e) { }
}
/* Жетон запуска: каждая остановка его меняет. Запуск, который дождался голоса
   после того, как человек уже переключил режим или нажал «Стоп», отменяется. */
var playToken = 0;
function stopAll() {
    playToken++;
    var c = cur;
    cur = null;
    clearTimers();
    if (c) { try { c.stop(); } catch (e) { } }
    resetDest();
    uiIdle();
}
function begin(session) {
    cur = session;
    pill('run', T.pill_playing);
    markComplete();
    meterOn();
    lockWake(true);
}
var wake = false;
function lockWake(on) {
    try {
        var W = window.__wakeLock;
        if (!W || !W.hold) return;
        if (on && !wake) { W.hold(SLUG); wake = true; }
        if (!on && wake) { W.releaseHold(SLUG); wake = false; }
    } catch (e) { }
}
function uiIdle() {
    pill('ready', T.pill_ready);
    lockWake(false);
    qa('.st-tile', root).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    setQuick(false);
    var alt = $('stAlt'); if (alt) alt.setAttribute('aria-pressed', 'false');
    setBtn($('stBalPlay'), $('stBalPlayLbl'), false, T.play);
    setBtn($('stSurrAuto'), $('stSurrAutoLbl'), false, T.surr.auto);
    ['stSurrCirc', 'stSurrDrag'].forEach(function (id) { var b = $(id); if (b) b.setAttribute('aria-pressed', 'false'); });
    qa('.st-rspk', root).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    setBtn($('stSweepGo'), $('stSweepGoLbl'), false, T.fq.start);
    setBtn($('stGenPlay'), $('stGenPlayLbl'), false, T.play);
    setBtn($('stRattleGo'), $('stRattleGoLbl'), false, T.blownStart);
    qa('#stFreqs .dk-chip', root).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    var mk = $('stMark'); if (mk) mk.disabled = true;
    var rm = $('stRattleMark'); if (rm) rm.disabled = true;
    var room = $('stRoom'); if (room) room.classList.remove('interactive');
    var cur0 = $('stRoomCursor'); if (cur0) cur0.classList.remove('on');
    setText($('stSurrStatus'), '');
    sndLabel();
    meterZero();
}
/* Кнопка «играть/стоп» несёт и цвет состояния (зелёный пуск, красный стоп),
   и подпись — пиктограмму меняем вместе с ними. */
var ICON_PLAY = '<svg class="dk-i" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M8 5.5v13l10.5-6.5z"/></svg>';
var ICON_STOP = '<svg class="dk-i" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><rect x="6.5" y="6.5" width="11" height="11" rx="2"/></svg>';
function setBtn(btn, lbl, playing, idleText) {
    if (!btn) return;
    btn.classList.toggle('dk-go', !playing);
    btn.classList.toggle('dk-stop', !!playing);
    var ico = btn.querySelector('.st-qico');
    if (ico) ico.innerHTML = playing ? ICON_STOP : ICON_PLAY;
    if (lbl) setText(lbl, playing ? T.stop : (idleText || lbl.textContent));
}
function setQuick(playing) { setBtn($('stQuick'), $('stQuickLbl'), playing, T.quick); }

/* ═══ РЕЖИМ «ЛЕВО / ПРАВО» ═══════════════════════════════════════════════════ */
var CLIP_KEY = { L: 'left', R: 'right', C: 'center' };
function chText(ch) { return ch === 'C' && S.lr.invert ? T.now_Cinv : T['now_' + ch]; }
function markHeard(ch) {
    if (ch !== 'R') S.lr.heardL = true;
    if (ch !== 'L') S.lr.heardR = true;
    if (S.lr.heardL && S.lr.heardR) showVerdict();
}
/* Карточки итога видны в СВОЁМ режиме и только когда им есть что сказать. */
function showResult(id) { var el = $(id); if (!el) return; el.setAttribute('data-has', '1'); el.hidden = el.getAttribute('data-result') !== S.mode; }
function hideResult(id) { var el = $(id); if (!el) return; el.removeAttribute('data-has'); el.hidden = true; }
function showVerdict() {
    var v = $('stVerdict');
    if (!v || v.hasAttribute('data-has')) return;
    showResult('stVerdict');
    funnel('verdict_shown');
}
function lightTile(ch) {
    qa('.st-tile', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ch') === ch ? 'true' : 'false'); });
}
/* pattern: 'single' (один канал, пока не остановят), 'alt' (по очереди),
   'quick' (левый → правый → оба, один раз). */
function startLr(pattern, ch) {
    var p = ready();
    var snd = S.lr.snd;
    var useVoice = snd === 'voice';
    return p.then(function () {
        stopAll();
        var tok = playToken;
        if (useVoice) loading();
        var wait = useVoice ? voice(['left', 'right', 'center']).catch(function (e) { voiceFailed(e); return null; }) : Promise.resolve(null);
        return wait.then(function (clips) {
            if (cur || tok !== playToken) return;  // пока грузился голос, человек уже нажал другое
            var vv = !!clips;
            var route = makeRoute();
            var src = vv ? null : continuous(useVoice ? 't440' : snd, route);
            var plan = pattern === 'quick' ? C.quickPlan(vv ? { L: clips.left.duration, R: clips.right.duration, C: clips.center.duration } : null) : null;
            var t0 = ctx.currentTime + 0.04, nextT = t0, idx = 0, endAt = 0, alive = true, voices = [], ui = [];
            function step(i) {
                if (pattern === 'quick') return plan[i] || null;
                var c = pattern === 'alt' ? (i % 2 ? 'R' : 'L') : ch;
                if (!vv) return { ch: c, dur: pattern === 'alt' ? 1.0 : Infinity };
                return { ch: c, dur: clips[CLIP_KEY[c]].duration + (pattern === 'alt' ? 0.45 : 0.6) };
            }
            function schedule(st, t, n) {
                route.set(C.pairGains(st.ch, S.lr.invert && st.ch === 'C'), t);
                if (vv) {
                    var b = ctx.createBufferSource();
                    b.buffer = clips[CLIP_KEY[st.ch]];
                    var vg = ctx.createGain(); vg.gain.value = 1;
                    b.connect(vg); vg.connect(route.gl); vg.connect(route.gr);
                    b.onended = function () { try { vg.disconnect(); } catch (e) { } };
                    b.start(t);
                    voices.push(b);
                }
                ui.push({ t: t, ch: st.ch, n: n });
            }
            /* Экран идёт за СЛЫШИМЫМИ часами звука, а не за таймером: свежий
               контекст открывает устройство 0,5–1,3 с, и всё это время его часы
               стоят. Таймер, посчитанный от них, зажигал «звучит левый» раньше,
               чем звук появлялся. */
            function heardNow() {
                try { return window.AudibleClock ? window.AudibleClock.audible(ctx, ctx.currentTime) : ctx.currentTime; } catch (e) { return ctx.currentTime; }
            }
            function pump() {
                if (!alive) return;
                var now = ctx.currentTime;
                while (!endAt && nextT !== Infinity && nextT < now + 0.35) {
                    var st = step(idx);
                    if (!st) { endAt = nextT; break; }
                    schedule(st, nextT, idx + 1);
                    idx++;
                    nextT = st.dur === Infinity ? Infinity : nextT + st.dur;
                }
                var heard = heardNow();
                while (ui.length && ui[0].t <= heard + 0.01) {
                    var e = ui.shift();
                    session.ch = e.ch;
                    lightTile(e.ch);
                    var label = pattern === 'quick' ? fill(T.quick_step, { n: e.n, total: plan.length }) + ' · ' : pattern === 'alt' ? T.now_alt + ' · ' : '';
                    status(label + chText(e.ch));
                    markHeard(e.ch);
                }
                if (endAt && heard >= endAt) { finish(); return; }
                if (ui.length || nextT !== Infinity || endAt) later(pump, 40);
            }
            function finish() {
                if (!alive) return;
                stopAll();
                if (pattern === 'quick') { status(T.quick_done); showVerdict(); }
            }
            var session = {
                kind: 'lr', pattern: pattern, ch: pattern === 'single' ? ch : null,
                stop: function () {
                    alive = false;
                    if (src) src.stop();
                    voices.forEach(function (b) { try { b.stop(); } catch (e) { } });
                    route.set({ l: 0, r: 0 }, null, 0.01);
                    route.off();
                }
            };
            begin(session);
            if (pattern === 'single') lightTile(ch);   // нажатие принято — сразу, звук догонит
            setQuick(true);
            if (pattern === 'alt') { var a = $('stAlt'); if (a) a.setAttribute('aria-pressed', 'true'); }
            pump();
            feat('st_play', { m: 'lr', p: pattern, snd: vv ? 'voice' : snd, vol: volPct() });
        });
    }).catch(function (e) { audioFail(e, 'st_lr'); });
}
qa('.st-tile', root).forEach(function (b) {
    b.addEventListener('click', function () {
        /* Переводчик страницы (встроенный в браузер) умеет переписать кнопку
           целиком и потерять data-ch — тогда это «оба», а не NaN в AudioParam. */
        var ch = b.getAttribute('data-ch');
        if (!/^[LCR]$/.test(ch || '')) ch = 'C';
        if (cur && cur.kind === 'lr' && cur.pattern === 'single' && cur.ch === ch) { stopAll(); return; }
        startLr('single', ch);
    });
});
$('stQuick').addEventListener('click', function () {
    if (cur && cur.kind === 'lr') { stopAll(); return; }
    startLr('quick');
});
$('stAlt').addEventListener('click', function () {
    if (cur && cur.kind === 'lr' && cur.pattern === 'alt') { stopAll(); return; }
    startLr('alt');
});
/* Звук и фаза меняются на ходу: то, что играет, перезапускается тем же
   способом (а не переключается кнопкой — та бы остановила). */
function restartLr() {
    if (!cur || cur.kind !== 'lr') return;
    var p = cur.pattern, ch = cur.ch;
    if (p === 'quick') return;
    startLr(p, ch);
}
function chipGroup(id, onPick) {
    var g = $(id);
    if (!g) return;
    qa('.dk-chip', g).forEach(function (b) {
        b.addEventListener('click', function () {
            qa('.dk-chip', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            onPick(b.getAttribute('data-snd') || b.getAttribute('data-sweep') || b.getAttribute('data-wave') || b.getAttribute('data-hz'), b);
        });
    });
}
function pressedIn(id, attr) { var b = $(id) && $(id).querySelector('[aria-pressed="true"]'); return b ? b.getAttribute(attr) : null; }
/* Звук в два уровня: вид (голос · тон · шум · свип · бас) и вариант вида
   (частота тона, цвет шума). Вариант помнится: вернувшись к «Тону», человек
   получает ту частоту, что выбирал. */
var VOICE_OK = !!document.querySelector('#stSndMain [data-main="voice"]');
var lastTone = 't440', lastNoise = 'pink';
function mainOf(v) { return v === 'voice' ? 'voice' : /^t(\d|1k)/.test(v) ? 'tone' : /^(pink|white|brown)$/.test(v) ? 'noise' : v; }
function paintSnd() {
    var m = mainOf(S.lr.snd);
    qa('#stSndMain .dk-chip', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-main') === m ? 'true' : 'false'); });
    var tone = $('stSndTone'), noise = $('stSndNoise');
    if (tone) tone.hidden = m !== 'tone';
    if (noise) noise.hidden = m !== 'noise';
    qa('#stSndTone .dk-chip, #stSndNoise .dk-chip', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-snd') === S.lr.snd ? 'true' : 'false'); });
}
function pickSnd(v, quiet) {
    if (v === 'voice' && !VOICE_OK) v = 't440';
    S.lr.snd = v;
    if (mainOf(v) === 'tone') lastTone = v;
    if (mainOf(v) === 'noise') lastNoise = v;
    if (!quiet) { try { window.__toolSettings && window.__toolSettings.save(SLUG, 'snd', v); } catch (e) { } }
    paintSnd();
    sndLabel();
    if (!quiet) restartLr();
}
qa('#stSndMain .dk-chip', root).forEach(function (b) {
    b.addEventListener('click', function () {
        var m = b.getAttribute('data-main');
        pickSnd(m === 'tone' ? lastTone : m === 'noise' ? lastNoise : m);
    });
});
qa('#stSndTone .dk-chip, #stSndNoise .dk-chip', root).forEach(function (b) {
    b.addEventListener('click', function () { pickSnd(b.getAttribute('data-snd')); });
});
(function restoreSnd() {
    var saved = null;
    try { saved = window.__toolSettings && window.__toolSettings.load(SLUG, 'snd', null); } catch (e) { }
    /* «Бас 60 Гц» и свип из памяти не возвращаются: оба лежат ниже того, что
       играет динамик телефона или ноутбука (свип за 3,6 с «Быстрой проверки»
       доходит лишь до 450 Гц). Выбор прошлого визита — часто в наушниках —
       делал первую проверку сегодняшнего немой (жалоба 20.10.2026, Redmi:
       «Нет звука», а играл бас). Внутри визита выбор держится. */
    var known = /^(voice|t220|t440|t880|t1k|pink|white|brown)$/;
    pickSnd(saved && known.test(saved) ? saved : (VOICE_OK ? 'voice' : 't440'), true);
})();
var $inv = $('stInvert');
if ($inv) $inv.addEventListener('change', function () {
    S.lr.invert = !!$inv.checked;
    var tag = $('stInvTag'); if (tag) tag.hidden = !S.lr.invert;
    if (S.lr.invert) feat('st_phase', { on: 1 });
    if (cur && cur.kind === 'lr' && cur.ch === 'C') restartLr();
});

/* Вердикт: «что вы услышали» → названная неисправность и шаги. */
function verdict(kind) {
    var out = $('stVerdictResult'), V = T.v, tips = T.tips, os = osKey(), html = '', cls = 'warn';
    if (kind === 'both') {
        cls = 'ok';
        html = '<h4>' + esc(V.ok) + '</h4><p>' + esc(V.ok_body) + '</p>';
    } else if (kind === 'swapped') {
        html = '<h4>' + esc(V.swapped) + '</h4>' + list(tips.swapped);
    } else if (kind === 'left' || kind === 'right') {
        var tl = tips.oneside.slice();
        if (os && tips.os[os]) tl.unshift(tips.os[os]);
        html = '<h4>' + esc(kind === 'left' ? V.left : V.right) + '</h4><p>' + esc(V.mono_note) + '</p>' + list(tl)
            + '<div class="dk-row"><a class="dk-btn dk-sm" href="' + esc(T.fq.cleaner_url) + '">' + esc(V.cleaner) + '</a></div>';
    } else if (kind === 'quieter') {
        cls = '';
        html = '<h4>' + esc(V.quieter) + '</h4><p>' + esc(V.quieter_body) + '</p>'
            + '<div class="dk-row"><button type="button" class="dk-btn dk-sm dk-primary" data-goto="bal">' + esc(V.goto_bal) + '</button></div>';
    } else if (S.lr.snd === 'bass') {
        /* Тишина на басе — не «звук теряется по дороге»: 60 Гц динамик телефона
           или ноутбука почти не играет. Сначала это, проверка выхода — вторым. */
        html = '<h4>' + esc(V.none) + '</h4><p>' + esc(fill(V.low_snd, { sound: T.snd.bass })) + '</p>'
            + '<div class="dk-row"><button type="button" class="dk-btn dk-sm dk-primary" data-try-voice>' + esc(V.try_voice) + '</button>'
            + '<button type="button" class="dk-btn dk-sm" data-goto="fix" data-prob="none">' + esc(V.goto_fix) + '</button></div>';
    } else {
        html = '<h4>' + esc(V.none) + '</h4><p>' + esc(V.none_body) + '</p>'
            + '<div class="dk-row"><button type="button" class="dk-btn dk-sm dk-primary" data-goto="fix" data-prob="none">' + esc(V.goto_fix) + '</button></div>';
    }
    out.className = 'st-out-box ' + cls;
    out.innerHTML = html;
    out.hidden = false;
    funnel('verdict_answered', { answer: kind, snd: S.lr.snd, vol: volPct() });
}
qa('.st-vopt', root).forEach(function (b) {
    b.addEventListener('click', function () {
        qa('.st-vopt', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        verdict(b.getAttribute('data-v'));
    });
});

/* ═══ РЕЖИМ «БАЛАНС» ═════════════════════════════════════════════════════════ */
var $bal = $('stBal'), $balDot = $('stBalDot'), $balV = $('stBalReadV'), $balS = $('stBalReadS'), $balOk = $('stBalOk');
function balDb() { var v = parseInt($bal.value, 10); return isFinite(v) ? v / 10 : 0; }
function balChannel() { return S.bal.swapped ? -balDb() : balDb(); }
function balPaint() {
    var b = balDb();
    paintRange($bal);
    /* Точка сдвигается туда, КУДА смещён звук: громче правый канал — звук правее. */
    var pct = 50 + (b / C.BAL_MAX) * 42;
    if ($balDot) pxWrite($balDot, 'left', pct);
    var B = T.bal;
    setText($balV, Math.abs(b) < 0.25 ? B.pos_center : fill(b > 0 ? B.pos_right : B.pos_left, { db: fmtDb(b) }));
    if (cur && cur.kind === 'bal') cur.route.set(C.balanceGains(balChannel()), null, 0.02);
}
function balStart() {
    var s = C.randomStart();
    $bal.value = String(Math.round(s * 10));
    S.bal.moved = false;
    if ($balOk) $balOk.disabled = true;
    setText($balS, T.bal.lead);
    balPaint();
}
function balMoved() {
    if (!S.bal.moved) { S.bal.moved = true; if ($balOk) $balOk.disabled = false; }
    balPaint();
}
$bal.addEventListener('input', balMoved);
qa('.st-nudge', root).forEach(function (b) {
    var stepFn = function () {
        var v = parseInt($bal.value, 10) + parseInt(b.getAttribute('data-nudge'), 10) * 5;
        v = Math.max(+$bal.min, Math.min(+$bal.max, v));
        if (String(v) === $bal.value) return false;
        $bal.value = String(v); balMoved();
        return true;
    };
    if (window.__holdRepeat) window.__holdRepeat(b, stepFn);
    b.addEventListener('click', function () { stepFn(); });
});
function balPlay() {
    if (cur && cur.kind === 'bal') { stopAll(); return; }
    var p = ready();
    var snd = S.bal.snd;
    p.then(function () {
        stopAll();
        var useVoice = snd === 'voice', tok = playToken;
        if (useVoice) loading();
        var wait = useVoice ? voice(['center']).catch(function (e) { voiceFailed(e); return null; }) : Promise.resolve(null);
        return wait.then(function (clips) {
            if (cur || tok !== playToken) return;
            var route = makeRoute();
            route.set(C.balanceGains(balChannel()), null, 0.005);
            var src = null, alive = true, voices = [];
            if (clips) {
                var t = ctx.currentTime + 0.04, d = clips.center.duration + 0.5;
                var pump = function () {
                    if (!alive) return;
                    while (t < ctx.currentTime + 0.35) {
                        var b = ctx.createBufferSource(); b.buffer = clips.center;
                        b.connect(route.gl); b.connect(route.gr); b.start(t); voices.push(b); t += d;
                    }
                    later(pump, 80);
                };
                pump();
            } else src = continuous(snd === 't1k' ? 't1k' : 'pink', route);
            begin({ kind: 'bal', ch: 'C', route: route, stop: function () {
                alive = false; if (src) src.stop();
                voices.forEach(function (b) { try { b.stop(); } catch (e) { } });
                route.set({ l: 0, r: 0 }, null, 0.01); route.off();
            } });
            setBtn($('stBalPlay'), $('stBalPlayLbl'), true, T.play);
            feat('st_play', { m: 'bal', snd: clips ? 'voice' : snd });
        });
    }).catch(function (e) { audioFail(e, 'st_bal'); });
}
$('stBalPlay').addEventListener('click', balPlay);
S.bal.snd = pressedIn('stBalSounds', 'data-snd') || 'pink';
chipGroup('stBalSounds', function (v) {
    S.bal.snd = v;
    if (cur && cur.kind === 'bal') { stopAll(); balPlay(); }
    sndLabel();
});
$('stBalReset').addEventListener('click', function () {
    S.bal.swapped = false; S.bal.b1 = null;
    $('stSwapTag').hidden = true;
    hideResult('stBalResult');
    balStart();
});
$balOk.addEventListener('click', function () {
    if (!S.bal.moved) { setText($balS, T.bal.need_move); return; }
    var B = T.bal, bc = balChannel(), out = $('stBalOut'), html = '', os = osKey();
    if (!S.bal.swapped) {
        S.bal.b1 = bc;
        var r = C.balanceReading(bc);
        html = '<div class="st-big">' + esc(r.grade === 'same' ? B.r_same : fill(r.quieter === 'left' ? B.r_left : B.r_right, { db: fmtDb(r.db) })) + '</div>'
            + '<p>' + esc(B['g_' + r.grade]) + '</p>';
        if (r.grade !== 'same') {
            html += '<p>' + esc(B.swap_q) + '</p><div class="dk-row"><button type="button" class="dk-btn dk-sm dk-primary" id="stSwapGo">' + esc(B.swap_btn) + '</button></div>'
                + '<p class="dk-hint" style="margin-top:8px">' + esc(B.speakers_note) + '</p>';
        }
        out.className = 'st-out-box ' + (r.grade === 'same' ? 'ok' : r.grade === 'slight' ? '' : 'warn');
        feat('st_bal', { n: 1, db: r.db, side: r.quieter, grade: r.grade });
    } else {
        var v = C.swapVerdict(S.bal.b1, bc), head = '', tips = [];
        if (v.kind === 'bud') { head = fill(v.bud.quieter === 'left' ? B.v_bud_left : B.v_bud_right, { db: fmtDb(v.bud.db) }); tips = T.tips.bud.slice(); }
        else if (v.kind === 'ear') { head = fill(v.ear.quieter === 'left' ? B.v_ear_left : B.v_ear_right, { db: fmtDb(v.ear.db) }); tips = T.tips.ear.slice(); }
        else if (v.kind === 'both') {
            head = fill(B.v_both, {
                bud_side: B['side_bud_' + v.bud.quieter], bud: fmtDb(v.bud.db),
                ear_side: B['side_ear_' + v.ear.quieter], ear: fmtDb(v.ear.db)
            });
            tips = T.tips.bud.slice(0, 2).concat(T.tips.ear.slice(0, 1));
        } else head = B.v_gone;
        html = '<div class="st-big">' + esc(head) + '</div>' + (tips.length ? list(tips) : '');
        if (v.kind === 'bud' || v.kind === 'both') {
            var ost = os && T.tips.os[os];
            if (ost) html += '<p>' + esc(B.os_lead) + ' ' + esc(ost) + '</p>';
        }
        if (v.kind === 'ear' || v.kind === 'both') html += '<div class="dk-row"><a class="dk-btn dk-sm" href="' + esc(B.hearing_url) + '">' + esc(B.hearing) + '</a></div>';
        html += '<div class="dk-row"><button type="button" class="dk-btn dk-sm dk-quiet" id="stBalAgain">' + esc(B.again) + '</button></div>';
        out.className = 'st-out-box ' + (v.kind === 'gone' ? '' : 'warn');
        feat('st_bal_swap', { kind: v.kind, bud: v.bud.db, ear: v.ear.db });
    }
    out.innerHTML = html;
    showResult('stBalResult');
    say(out.textContent.slice(0, 160));
});
$('stBalResult').addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t) return;
    if (t.id === 'stSwapGo') {
        S.bal.swapped = true;
        $('stSwapTag').hidden = false;
        hideResult('stBalResult');
        balStart();
        if (!cur) balPlay();
    } else if (t.id === 'stBalAgain') {
        $('stBalReset').click();
    }
});

/* ═══ РЕЖИМ «5.1 / 7.1» ══════════════════════════════════════════════════════ */
/* Позиции на круглой схеме: x = 50 + 38·sin(угол), y = 50 − 38·cos(угол). */
var CH51 = [
    { id: 'fl', spk: 'L', kind: 'front', x: 31, y: 17, voice: 'front_left' },
    { id: 'c', spk: 'C', kind: 'center', x: 50, y: 12, voice: 'center' },
    { id: 'fr', spk: 'R', kind: 'front', x: 69, y: 17, voice: 'front_right' },
    { id: 'sl', spk: 'SL', kind: 'surround', x: 13, y: 61, voice: 'surround_left' },
    { id: 'lfe', spk: 'SUB', kind: 'sub', x: 50, y: 70, voice: null },
    { id: 'sr', spk: 'SR', kind: 'surround', x: 87, y: 61, voice: 'surround_right' }
];
var CH71 = [
    CH51[0], CH51[1], CH51[2],
    { id: 'sl', spk: 'SL', kind: 'surround', x: 12, y: 50, voice: 'side_left', l71: true },
    CH51[4],
    { id: 'sr', spk: 'SR', kind: 'surround', x: 88, y: 50, voice: 'side_right', l71: true },
    { id: 'bl', spk: 'SBL', kind: 'surround', x: 26, y: 83, voice: 'back_left' },
    { id: 'br', spk: 'SBR', kind: 'surround', x: 74, y: 83, voice: 'back_right' }
];
function surrList() { return S.surr.cfg === '71' ? CH71 : CH51; }
function surrLabel(ch) { return T.surr[ch.l71 ? ch.id + '71' : ch.id] || ch.id; }
var $room = $('stRoom');
function buildRoom() {
    qa('.st-rspk', $room).forEach(function (e) { e.remove(); });
    surrList().forEach(function (ch) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'st-rspk';
        b.setAttribute('data-sid', ch.id); b.setAttribute('data-kind', ch.kind); b.setAttribute('aria-pressed', 'false');
        b.style.left = ch.x + '%'; b.style.top = ch.y + '%';
        b.innerHTML = '<i aria-hidden="true"></i><span>' + esc(surrLabel(ch)) + '</span>';
        b.addEventListener('click', function () {
            if (cur && cur.kind === 'surr' && cur.run === 'manual' && cur.sid === ch.id) { stopAll(); return; }
            surrPlay('manual', ch);
        });
        $room.appendChild(b);
    });
}
function capText() {
    var el = $('stCap'), tx = $('stCapText');
    if (!el || !tx || !window.SurroundEngine) return;
    if (!ctx) { el.className = 'st-cap'; tx.textContent = T.surr.cap_checking; return; }
    var setup = S.surr.cfg === '71' ? '7.1' : '5.1';
    var cap = window.SurroundEngine.capabilities(ctx, setup);
    el.className = 'st-cap ' + (cap.mode === 'discrete' ? 'is-real' : 'is-sim');
    tx.textContent = fill(cap.mode === 'discrete' ? T.surr.cap_real : T.surr.cap_sim, { setup: setup, max: cap.maxChannels }).replace(/\{(\w+)\}/g, function (m, k) { return k === 'setup' ? setup : k === 'max' ? cap.maxChannels : m; });
}
var LOOPS = {};
function loopBuf(key, clip) {
    var hit = LOOPS[key];
    if (hit && hit.c === ctx) return hit.b;
    var sr = clip.sampleRate, pad = Math.floor(sr * 0.65), n = clip.length + pad;
    var b = ctx.createBuffer(1, n, sr);
    b.getChannelData(0).set(clip.getChannelData(0));
    LOOPS[key] = { c: ctx, b: b };
    return b;
}
function bus() {
    var max = 2;
    try { max = ctx.destination.maxChannelCount || 2; } catch (e) { }
    if (!surrBus || surrBus.context !== ctx) {
        surrBus = ctx.createGain();
        surrBus.connect(ctx.destination);
    }
    surrBus.gain.value = volume();
    try {
        surrBus.channelCount = max; surrBus.channelCountMode = 'explicit'; surrBus.channelInterpretation = 'discrete';
        if (max > 2) { ctx.destination.channelCount = max; ctx.destination.channelCountMode = 'explicit'; ctx.destination.channelInterpretation = 'discrete'; }
    } catch (e) { }
    return surrBus;
}
/* run: manual (одна колонка), auto (обойти все один раз), circ (по кругу). */
function surrPlay(run, one) {
    var p = ready();
    var snd = S.surr.snd;
    p.then(function () {
        stopAll();
        if (!window.SurroundEngine) throw new Error('surround_engine_missing');
        var useVoice = snd === 'voice';
        /* Вручную нужен один клип — нажатая колонка звучит сразу, остальные
           догружаются фоном; обход и круг ждут всю схему (она понадобится
           через секунду). */
        var all = surrList().map(function (c) { return c.voice; }).filter(Boolean);
        var keys = run === 'manual' ? (one && one.voice ? [one.voice] : []) : all;
        if (useVoice && run === 'manual') all.forEach(function (k) { fetchVoice(k).catch(noop); });
        var tok = playToken;
        if (useVoice && keys.length) loading();
        var wait = useVoice && keys.length ? voice(keys).catch(function (e) { voiceFailed(e); return null; }) : Promise.resolve(null);
        return wait.then(function (clips) {
            if (cur || tok !== playToken) return;
            var setup = S.surr.cfg === '71' ? '7.1' : '5.1', out = bus(), handle = null, alive = true;
            var order = run === 'circ'
                ? ['fl', 'fr', 'sr', 'br', 'bl', 'sl'].map(function (id) { return surrList().filter(function (c) { return c.id === id; })[0]; }).filter(Boolean)
                : run === 'auto' ? surrList().slice() : [one];
            var i = 0;
            function playCh(ch) {
                if (handle) { handle.stop(); handle = null; }
                var opts = { ctx: ctx, dest: out, setup: setup, speakerId: ch.spk, gain: 0.9, freq: 440 };
                if (clips && ch.voice && clips[ch.voice]) { opts.signal = 'buffer'; opts.buffer = loopBuf(ch.voice, clips[ch.voice]); }
                else opts.signal = snd === 'noise' ? 'noise' : 'tone';
                handle = window.SurroundEngine.play(opts);
                session.sid = ch.id;
                qa('.st-rspk', $room).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sid') === ch.id ? 'true' : 'false'); });
                var tail = run === 'manual' ? '' : ' · ' + (i + 1) + '/' + order.length;
                setText($('stSurrStatus'), T.surr.playing + ': ' + surrLabel(ch) + tail);
                capText();
            }
            function stepDur(ch) {
                if (clips && ch.voice && clips[ch.voice]) return Math.max(run === 'circ' ? 1.6 : 2.2, (clips[ch.voice].duration + 0.65) * 2);
                return run === 'circ' ? 1.5 : 2.0;
            }
            function next() {
                if (!alive) return;
                if (i >= order.length) {
                    if (run === 'circ') i = 0; else { stopAll(); return; }
                }
                var ch = order[i];
                playCh(ch);
                if (run !== 'manual') later(function () { i++; next(); }, stepDur(ch) * 1000);
            }
            var session = { kind: 'surr', run: run, sid: null, stop: function () { alive = false; if (handle) handle.stop(); } };
            begin(session);
            if (run === 'auto') setBtn($('stSurrAuto'), $('stSurrAutoLbl'), true, T.surr.auto);
            if (run === 'circ') $('stSurrCirc').setAttribute('aria-pressed', 'true');
            next();
            feat('st_play', { m: 'surr', p: run, cfg: S.surr.cfg, snd: clips ? 'voice' : snd });
        });
    }).catch(function (e) { audioFail(e, 'st_surr'); });
}
/* «Вести курсором» — свободная панорама по стерео; честное превью позиции, не
   дискретный канал (так и сказано в подсказке). */
function surrDrag() {
    var p = ready();
    p.then(function () {
        stopAll();
        var route = makeRoute(), src = continuous(S.surr.snd === 'tone' ? 't440' : 'pink', route), alive = true;
        route.set(C.panGains(0), null, 0.005);
        $room.classList.add('interactive');
        var cursor = $('stRoomCursor');
        function move(e) {
            if (!alive) return;
            var pt = e.touches ? e.touches[0] : e, r = $room.getBoundingClientRect();
            var x = (pt.clientX - r.left) / r.width, y = (pt.clientY - r.top) / r.height;
            route.set(C.panGains((x - 0.5) * 2), null, 0.02);
            if (cursor) { cursor.style.left = Math.max(0, Math.min(100, x * 100)) + '%'; cursor.style.top = Math.max(0, Math.min(100, y * 100)) + '%'; cursor.classList.add('on'); }
        }
        $room.addEventListener('pointermove', move);
        $room.addEventListener('pointerdown', move);
        begin({ kind: 'surr', run: 'drag', stop: function () {
            alive = false; src.stop(); route.off();
            $room.removeEventListener('pointermove', move); $room.removeEventListener('pointerdown', move);
        } });
        $('stSurrDrag').setAttribute('aria-pressed', 'true');
        setText($('stSurrStatus'), T.surr.drag);
        feat('st_play', { m: 'surr', p: 'drag' });
    }).catch(function (e) { audioFail(e, 'st_surr_drag'); });
}
$('stSurrAuto').addEventListener('click', function () { if (cur && cur.kind === 'surr' && cur.run === 'auto') { stopAll(); return; } surrPlay('auto'); });
$('stSurrCirc').addEventListener('click', function () { if (cur && cur.kind === 'surr' && cur.run === 'circ') { stopAll(); return; } surrPlay('circ'); });
$('stSurrDrag').addEventListener('click', function () { if (cur && cur.kind === 'surr' && cur.run === 'drag') { stopAll(); return; } surrDrag(); });
qa('#stCfg button', root).forEach(function (b) {
    b.addEventListener('click', function () {
        stopAll();
        qa('#stCfg button', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        S.surr.cfg = b.getAttribute('data-cfg');
        buildRoom(); capText();
    });
});
S.surr.snd = pressedIn('stSurrSounds', 'data-snd') || 'tone';
chipGroup('stSurrSounds', function (v) {
    S.surr.snd = v; sndLabel();
    if (cur && cur.kind === 'surr') { var run = cur.run, sid = cur.sid; stopAll(); if (run === 'drag') surrDrag(); else surrPlay(run, surrList().filter(function (c) { return c.id === sid; })[0]); }
});
buildRoom();

/* ═══ РЕЖИМ «ЧАСТОТЫ» ════════════════════════════════════════════════════════ */
var $fqBig = $('stFqBig'), $fqSub = $('stFqSub'), $fqBar = $('stFqBar'), $marks = $('stFqMarks');
var canvas = $('stCanvas'), cctx = canvas && canvas.getContext ? canvas.getContext('2d') : null, vizRaf = 0;
function fqShow(hz, sub) {
    if ($fqBig) $fqBig.innerHTML = hz ? fmtHzHtml(hz) : '— <small>' + esc(T.unit_hz) + '</small>';
    if (sub != null) setText($fqSub, sub);
}
function fqBar(frac) { if ($fqBar) $fqBar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, frac)).toFixed(4) + ')'; }
function vizSize() {
    if (!canvas) return;
    var r = canvas.getBoundingClientRect(); if (r.width < 2) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
    if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
}
function vizFrame() {
    vizRaf = 0;
    if (!cctx || !anS || !cur || S.mode !== 'freq' || document.hidden) { if (cctx) cctx.clearRect(0, 0, canvas.width, canvas.height); return; }
    anS.getByteFrequencyData(bufS);
    var w = canvas.width, h = canvas.height, n = bufS.length, sr = ctx.sampleRate;
    cctx.clearRect(0, 0, w, h);
    /* Логарифмическая ось 20 Гц — 20 кГц: по линейной вся музыкальная середина
       сжата в левый край. */
    var bars = Math.max(24, Math.min(96, Math.floor(w / 9))), lo = Math.log(20), hi = Math.log(20000);
    var bw = w / bars;
    for (var i = 0; i < bars; i++) {
        var f0 = Math.exp(lo + (hi - lo) * i / bars), f1 = Math.exp(lo + (hi - lo) * (i + 1) / bars);
        var a = Math.floor(f0 / (sr / 2) * n), z = Math.max(a + 1, Math.floor(f1 / (sr / 2) * n)), m = 0;
        for (var k = a; k < z && k < n; k++) if (bufS[k] > m) m = bufS[k];
        var v = m / 255, bh = Math.max(1, v * h);
        cctx.fillStyle = 'hsla(' + (215 + v * 120) + ',85%,' + (55 + v * 10) + '%,' + (0.35 + v * 0.65) + ')';
        cctx.fillRect(i * bw + 1, h - bh, Math.max(1, bw - 2), bh);
    }
    vizRaf = requestAnimationFrame(vizFrame);
}
function vizOn() { vizSize(); if (!vizRaf) vizRaf = requestAnimationFrame(vizFrame); }
window.addEventListener('resize', function () { if (S.mode === 'freq') vizSize(); });

/* Один тон в оба канала (отдельные частоты, генератор). */
function toneSession(hz, wave, kind) {
    var route = makeRoute(), o = osc(hz, wave), g = ctx.createGain(), env = ctx.createGain(), t = ctx.currentTime;
    g.gain.value = TONE_AMP;
    env.gain.setValueAtTime(0, t); env.gain.linearRampToValueAtTime(1, t + 0.05);
    o.connect(g); g.connect(env); env.connect(route.gl); env.connect(route.gr);
    route.set(C.pairGains('C'), null, 0.005);
    o.start();
    return { kind: kind, osc: o, stop: function () {
        var n = ctx.currentTime;
        try { env.gain.setValueAtTime(env.gain.value, n); env.gain.linearRampToValueAtTime(0, n + 0.04); } catch (e) { }
        setTimeout(function () { try { o.stop(); } catch (e) { } route.off(); }, 70);
    } };
}
function sweepSession(sw, kind, onEnd) {
    var route = makeRoute(), o = osc(sw.f0), g = ctx.createGain(), t0 = ctx.currentTime + 0.05;
    g.gain.value = 0;
    g.gain.setValueAtTime(0, t0); g.gain.linearRampToValueAtTime(TONE_AMP, t0 + 0.08);
    g.gain.setValueAtTime(TONE_AMP, t0 + sw.dur - 0.08); g.gain.linearRampToValueAtTime(0, t0 + sw.dur);
    o.frequency.setValueAtTime(sw.f0, t0);
    o.frequency.exponentialRampToValueAtTime(sw.f1, t0 + sw.dur);
    o.connect(g); g.connect(route.gl); g.connect(route.gr);
    route.set(C.pairGains('C'), null, 0.005);
    o.start(t0); o.stop(t0 + sw.dur + 0.02);
    var alive = true, lastTxt = 0;
    function tick() {
        if (!alive) return;
        var el = ctx.currentTime - t0;
        var heard = window.AudibleClock ? window.AudibleClock.audible(ctx, ctx.currentTime) - t0 : el;
        fqBar(heard / sw.dur);
        var now = performance.now();
        if (now - lastTxt > 90) { lastTxt = now; fqShow(C.sweepFreqAt(sw.f0, sw.f1, sw.dur, heard)); }
        if (el >= sw.dur + 0.05) { alive = false; onEnd && onEnd(); return; }
        later(tick, 40);
    }
    tick();
    return { kind: kind, t0: t0, sw: sw, stop: function () { alive = false; try { o.stop(); } catch (e) { } route.off(); } };
}
function drawMark(sw, hz) {
    if (!$marks) return;
    var frac = Math.log(hz / sw.f0) / Math.log(sw.f1 / sw.f0);
    var m = document.createElement('span');
    m.className = 'st-mark'; m.style.left = (Math.max(0, Math.min(1, frac)) * 100) + '%';
    $marks.appendChild(m);
}
function clearMarks() { if ($marks) $marks.innerHTML = ''; }
function fqResult(html, cls) {
    var out = $('stFqOut'); if (!out) return;
    out.className = 'st-out-box ' + (cls || '');
    out.innerHTML = html;
    showResult('stFqResult');
}
function sweepEnd() {
    var key = S.freq.sweep, sw = C.SWEEPS[key], marks = S.freq.marks, F = T.fq;
    stopAll();
    fqBar(0);
    var html;
    if (!marks.length) html = '<p>' + esc(F.res_none) + '</p>';
    else if (sw.mark === 'onset') html = '<div class="st-big">' + esc(fill(F.res_onset, { f: fmtHz(marks[0]) })) + '</div>';
    else if (sw.mark === 'offset') html = '<div class="st-big">' + esc(fill(F.res_offset, { f: fmtHz(marks[marks.length - 1]) })) + '</div>';
    else html = '<div class="st-big">' + esc(fill(F.res_note, { list: marks.map(fmtHz).join(', ') })) + '</div>';
    if (marks.length) html += '<p class="dk-hint" style="margin-top:6px">' + esc(F.res_hint) + ' <a href="' + esc(F.hearing_url) + '">' + esc(F.hearing) + '</a></p>';
    fqResult(html, marks.length ? 'ok' : '');
    if (marks.length) feat('st_sweep_mark', { r: key, hz: Math.round(marks[sw.mark === 'onset' ? 0 : marks.length - 1]), n: marks.length });
}
$('stSweepGo').addEventListener('click', function () {
    if (cur && cur.kind === 'sweep') { sweepEnd(); return; }
    var p = ready();
    p.then(function () {
        stopAll();
        var sw = C.SWEEPS[S.freq.sweep];
        S.freq.marks = []; clearMarks();
        hideResult('stFqResult');
        var s = sweepSession(sw, 'sweep', sweepEnd);
        begin(s);
        setBtn($('stSweepGo'), $('stSweepGoLbl'), true, T.fq.start);
        $('stMark').disabled = false;
        setText($fqSub, T.fq.playing);
        vizOn();
        feat('st_play', { m: 'freq', p: 'sweep', r: S.freq.sweep });
    }).catch(function (e) { audioFail(e, 'st_sweep'); });
});
$('stMark').addEventListener('click', function () {
    if (!cur || cur.kind !== 'sweep') return;
    var heard = window.AudibleClock ? window.AudibleClock.audible(ctx, ctx.currentTime) : ctx.currentTime;
    var hz = C.markFrequency(cur.sw, cur.t0, heard);
    S.freq.marks.push(hz);
    drawMark(cur.sw, hz);
    say(fmtHz(hz));
    if (cur.sw.mark !== 'note') sweepEnd();
});
function markLabel() {
    var sw = C.SWEEPS[S.freq.sweep];
    setText($('stMarkLbl'), sw.mark === 'onset' ? T.fq.mark_onset : sw.mark === 'offset' ? T.fq.mark_offset : T.fq.mark_note);
}
S.freq.sweep = pressedIn('stSweeps', 'data-sweep') || 'high';
chipGroup('stSweeps', function (v) { S.freq.sweep = v; markLabel(); if (cur && cur.kind === 'sweep') stopAll(); });
markLabel();

qa('#stFreqs .dk-chip', root).forEach(function (b) {
    b.addEventListener('click', function () {
        var hz = parseInt(b.getAttribute('data-hz'), 10);
        if (cur && cur.kind === 'tone' && cur.hz === hz) { stopAll(); fqShow(0, ''); return; }
        var p = ready();
        p.then(function () {
            stopAll();
            var s = toneSession(hz, 'sine', 'tone'); s.hz = hz;
            begin(s);
            qa('#stFreqs .dk-chip', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            fqShow(hz, T.fq.tone_now); fqBar(0); clearMarks();
            vizOn();
            feat('st_play', { m: 'freq', p: 'tone', hz: hz });
        }).catch(function (e) { audioFail(e, 'st_tone'); });
    });
});

var $gen = $('stGen'), $genVal = $('stGenVal');
function genHz() { var v = parseInt($gen.value, 10); return 20 * Math.pow(1000, (isFinite(v) ? v : 449) / 1000); }
function genPaint() {
    var hz = genHz();
    setText($genVal, fmtHz(hz));
    paintRange($gen);
    if (cur && cur.kind === 'gen') { try { cur.osc.frequency.setTargetAtTime(hz, ctx.currentTime, 0.015); } catch (e) { } fqShow(hz); }
}
$gen.addEventListener('input', genPaint);
genPaint();
chipGroup('stWaves', function (v) { S.freq.wave = v; if (cur && cur.kind === 'gen') try { cur.osc.type = v; } catch (e) { } });
$('stGenPlay').addEventListener('click', function () {
    if (cur && cur.kind === 'gen') { stopAll(); return; }
    var p = ready();
    p.then(function () {
        stopAll();
        var s = toneSession(genHz(), S.freq.wave, 'gen');
        begin(s);
        setBtn($('stGenPlay'), $('stGenPlayLbl'), true, T.play);
        fqShow(genHz(), T.fq.tone_now); fqBar(0); clearMarks();
        vizOn();
        feat('st_play', { m: 'freq', p: 'gen' });
    }).catch(function (e) { audioFail(e, 'st_gen'); });
});

/* Дребезг: медленный свип 40–500 Гц, где ход диффузора самый большой. */
var $rLbl = $('stRattleGoLbl');
if ($rLbl) $rLbl.setAttribute('data-idle', $rLbl.textContent);
T.blownStart = $rLbl ? $rLbl.textContent : '';
function rattleEnd() {
    stopAll();
    fqBar(0);
    $('stRattleAsk').hidden = false;
    $('stRattleRun').hidden = true;
}
$('stRattleGo').addEventListener('click', function () {
    if (cur && cur.kind === 'rattle') { rattleEnd(); return; }
    var p = ready();
    p.then(function () {
        stopAll();
        S.freq.rattleMarks = []; clearMarks();
        hideResult('stFqResult'); $('stRattleAsk').hidden = true;
        var s = sweepSession(C.SWEEPS.rattle, 'rattle', rattleEnd);
        begin(s);
        setBtn($('stRattleGo'), $rLbl, true, T.blownStart);
        $('stRattleMark').disabled = false;
        setText($fqSub, T.fq.sweeping);
        vizOn();
        feat('st_play', { m: 'freq', p: 'rattle' });
    }).catch(function (e) { audioFail(e, 'st_rattle'); });
});
$('stRattleMark').addEventListener('click', function () {
    if (!cur || cur.kind !== 'rattle') return;
    var heard = window.AudibleClock ? window.AudibleClock.audible(ctx, ctx.currentTime) : ctx.currentTime;
    var hz = C.markFrequency(cur.sw, cur.t0, heard);
    S.freq.rattleMarks.push(hz);
    drawMark(cur.sw, hz);
    say(fmtHz(hz));
});
var blBoxes = qa('input[name="stBl"]', root);
blBoxes.forEach(function (c) {
    c.addEventListener('change', function () {
        if (!c.checked) return;
        if (c.value === 'none') blBoxes.forEach(function (x) { if (x !== c) x.checked = false; });
        else blBoxes.forEach(function (x) { if (x.value === 'none') x.checked = false; });
    });
});
$('stRattleCheck').addEventListener('click', function () {
    var checks = blBoxes.filter(function (c) { return c.checked; }).map(function (c) { return c.value; });
    var bad = checks.length && checks.indexOf('none') === -1, F = T.fq, marks = S.freq.rattleMarks;
    var html = '<h4>' + esc(bad ? F.blown_bad : F.blown_ok) + '</h4>';
    if (marks.length) {
        html += '<p>' + esc(fill(F.blown_marks, { list: marks.map(fmtHz).join(', ') })) + '</p>';
        if (marks.every(function (h) { return h < 80; })) html += '<p>' + esc(F.blown_low) + '</p>';
    }
    if (bad) html += '<div class="dk-row"><a class="dk-btn dk-sm" href="' + esc(F.cleaner_url) + '">' + esc(F.cleaner) + '</a></div>';
    fqResult(html, bad ? 'warn' : 'ok');
    feat('st_rattle', { bad: bad ? 1 : 0, marks: marks.length, checks: checks.join(',').slice(0, 60) });
});
$('stRattleRetry').addEventListener('click', function () {
    blBoxes.forEach(function (c) { c.checked = false; });
    $('stRattleAsk').hidden = true; $('stRattleRun').hidden = false;
    hideResult('stFqResult'); clearMarks();
});

qa('#stFsub .tc-seg-b', root).forEach(function (b) {
    b.addEventListener('click', function () { setFsub(b.getAttribute('data-fsub')); });
});
function setFsub(sub, keep) {
    var changed = S.freq.sub !== sub;
    if (changed) stopAll();
    S.freq.sub = sub;
    qa('#stFsub .tc-seg-b', root).forEach(function (x) {
        var on = x.getAttribute('data-fsub') === sub;
        x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    qa('[data-fpane]', root).forEach(function (p) { p.hidden = p.getAttribute('data-fpane') !== sub; });
    if (keep && !changed) return;
    hideResult('stFqResult');
    clearMarks(); fqBar(0); fqShow(sub === 'gen' ? genHz() : 0, '');
}

/* ═══ «НЕТ ЗВУКА?» ═══════════════════════════════════════════════════════════ */
var F = T.fix;
function stepState(id, state, html) {
    var el = $(id); if (!el) return;
    el.setAttribute('data-state', state || '');
    var d = $(id + 'D'); if (d && html != null) d.innerHTML = html;
}
function playbackSeconds() {
    try { var st = ctx && ctx.playbackStats; if (st && isFinite(st.totalDuration)) return { s: st.totalDuration, u: st.underrunEvents || 0 }; } catch (e) { }
    return null;
}
$('stBeep').addEventListener('click', function () {
    var btn = this;
    var p = ready();
    p.then(function () {
        stopAll();
        var route = makeRoute(), o = osc(880), g = ctx.createGain(), t = ctx.currentTime + 0.03;
        var peak = Math.max(0.5, TONE_AMP * 1.6);
        g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(peak, t + 0.04);
        g.gain.setValueAtTime(peak, t + 0.5); g.gain.linearRampToValueAtTime(0, t + 0.6);
        o.connect(g); g.connect(route.gl); g.connect(route.gr);
        route.set(C.pairGains('C'), null, 0.002);
        var t0 = ctx.currentTime;
        o.start(t); o.stop(t + 0.62);
        btn.disabled = true;
        markComplete();
        setTimeout(function () {
            btn.disabled = false; route.off();
            var advanced = ctx.currentTime - t0 > 0.4 && ctx.state === 'running';
            if (!advanced) { stepState('stChkBrowser', 'bad', esc(F.browser_bad)); feat('st_fix_beep', { ok: 0, st: ctx.state }); return; }
            var ps = playbackSeconds(), txt = esc(F.browser_ok), vp = volPct();
            if (ps) txt += ' ' + esc(fill(F.browser_stats, { s: NF1.format(ps.s), u: ps.u }));
            /* Сигнал идёт через ползунок прибора: у нуля он «отдан», но не слышен. */
            if (vp <= 10) txt += ' ' + esc(fill(F.browser_low_vol, { n: vp }));
            stepState('stChkBrowser', vp <= 10 ? 'bad' : 'ok', txt);
            feat('st_fix_beep', { ok: 1, u: ps ? ps.u : -1, vol: vp });
        }, 800);
    }).catch(function (e) {
        stepState('stChkBrowser', 'bad', esc(F.browser_busy));
        feat('st_fix_beep', { ok: 0, err: (e && e.name) || 'error' });
    });
});
function deviceStep() {
    var d = $('stChkDeviceD');
    if (!d) return;
    var name = deviceName();
    if (!window.AudioOutputPicker || !window.AudioOutputPicker.isSupported()) { d.textContent = F.device_default; return; }
    var md = window.__safeMediaDevices && window.__safeMediaDevices.has && window.__safeMediaDevices.has('enumerateDevices') ? navigator.mediaDevices : null;
    if (!md) { d.textContent = F.device_default; return; }
    md.enumerateDevices().then(function (devs) {
        var outs = devs.filter(function (x) { return x.kind === 'audiooutput' && x.deviceId && !/^(default|communications)$/i.test(x.deviceId); });
        var txt = name ? fill(F.device_named, { name: name }) : F.device_default;
        if (outs.length > 1) txt += ' ' + fill(F.device_many, { n: outs.length });
        d.textContent = txt;
    }).catch(function () { d.textContent = F.device_default; });
}
(function osFirst() {
    var os = osKey(), tip = os && T.tips.nosound_os[os], ol = $('stNoSoundTips');
    if (!tip || !ol) return;
    var li = document.createElement('li'); li.textContent = tip;
    ol.insertBefore(li, ol.firstChild);
})();

/* Микрофон слушает динамики — SpeakerProbe (тот же пробник, что в
   /speaker-cleaner, с его четырьмя ловушками, решёнными замером). Левый и
   правый по отдельности: мощность одной стороны через панораму. */
var probeLoad = null;
function loadProbe() {
    if (window.SpeakerProbe) return Promise.resolve(true);
    if (!probeLoad) {
        probeLoad = (window.__loadScriptsOnce ? window.__loadScriptsOnce(CFG.probeSrcs || [], 'speaker-probe') : Promise.reject(new Error('no_loader')))
            .then(function () { return !!window.SpeakerProbe; });
        probeLoad.catch(function () { probeLoad = null; });
    }
    return probeLoad;
}
function sideOut(side) {
    var m = ctx.createChannelMerger(2), g = ctx.createGain();
    if (side === 'L') g.connect(m, 0, 0); else if (side === 'R') g.connect(m, 0, 1); else { g.connect(m, 0, 0); g.connect(m, 0, 1); }
    m.connect(ctx.destination);
    return { node: g, off: function () { try { m.disconnect(); g.disconnect(); } catch (e) { } } };
}
/* Ответ микрофона — с тем, что делать дальше, а не «пропустите шаг».
   «none»: микрофон слышит комнату, но не динамики — звук теряется после
   браузера; первым — путь для своей ОС, затем вопрос, разделяющий устройство и
   браузер. «mic_silent»: микрофон отдаёт цифровую тишину — как его включить.
   До 20.10.2026 «mic_silent» звучал и при живом микрофоне (порог 0,008 в
   пробнике, docs/why/primitives/mic-flat.md): человек с молчащим динамиком
   слышал «микрофон ничего не принимает» и уходил ни с чем. */
function micResult(v) {
    var os = osKey();
    if (v === 'none') return esc(F.mic_none) + list([os && T.tips.nosound_os[os], F.mic_none_next]);
    if (v === 'mic_silent') return esc(F.mic_silent) + (os && F.flat_os && F.flat_os[os] ? list([F.flat_os[os]]) : '');
    return esc({ both: F.mic_both, left: F.mic_left, right: F.mic_right }[v] || '');
}
function micDb(r) { return r && r.diag && r.diag.micPeakDb != null ? r.diag.micPeakDb : null; }
var micBusy = false;
function openMic() {
    return window.__tmbGum({ audio: window.SpeakerProbe.MIC_CONSTRAINTS });
}
function closeMic(stream) {
    try { stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) { }
}
function probeSide(stream, side) {
    var o = sideOut(side);
    return window.SpeakerProbe.run({ ctx: ctx, micStream: stream, out: o.node, level: 0.3 })
        .then(function (r) { o.off(); return r; }, function (e) { o.off(); throw e; });
}
$('stMicBtn').addEventListener('click', function () {
    if (micBusy) return;
    var btn = this, p = ready();
    micBusy = true; btn.disabled = true;
    stopAll();
    pill('wait', T.pill_listen);
    var stream = null;
    p.then(loadProbe).then(function (ok) {
        if (!ok) throw new Error('probe_missing');
        return openMic();
    }).then(function (s) {
        stream = s;
        stepState('stChkMic', '', esc(F.mic_run_l));
        return probeSide(stream, 'L');
    }).then(function (rl) {
        stepState('stChkMic', '', esc(F.mic_run_r));
        return probeSide(stream, 'R').then(function (rr) { return [rl, rr]; });
    }).then(function (rs) {
        var v = C.micVerdict(rs[0], rs[1]);
        stepState('stChkMic', v === 'both' ? 'ok' : v === 'mic_silent' ? '' : 'bad', micResult(v));
        feat('st_mic', { v: v, dbL: micDb(rs[0]), dbR: micDb(rs[1]), vol: volPct() });
        var picker = window.AudioOutputPicker && window.AudioOutputPicker.isSupported();
        if (v === 'none' && picker) $('stScanBtn').hidden = false;
        if (outputPicker && outputPicker.refresh) outputPicker.refresh();
        deviceStep();
    }).catch(function (e) {
        var n = e && e.name;
        var msg = n === 'NotAllowedError' || n === 'SecurityError' ? F.mic_denied : F.mic_fail;
        stepState('stChkMic', 'bad', esc(msg));
        feat('st_mic', { v: 'err', err: String(n || (e && e.message) || 'error').slice(0, 40) });
    }).then(function () {
        if (stream) closeMic(stream);
        micBusy = false; btn.disabled = false;
        pill('ready', T.pill_ready);
    });
});
/* Поиск выхода: тот же сигнал в каждое устройство вывода по очереди. Нужны
   setSinkId (Chromium) и названия устройств (они есть после доступа к
   микрофону). Выбранный выход — только для этой страницы; систему человек
   переключает сам, и мы говорим, на что. */
$('stScanBtn').addEventListener('click', function () {
    if (micBusy) return;
    var btn = this, listEl = $('stScanList'), p = ready();
    micBusy = true; btn.disabled = true;
    stopAll();
    pill('wait', T.pill_listen);
    var stream = null, before = selectedDeviceId, results = [];
    p.then(loadProbe).then(function () { return openMic(); }).then(function (s) {
        stream = s;
        return navigator.mediaDevices.enumerateDevices();
    }).then(function (devs) {
        var outs = devs.filter(function (x) { return x.kind === 'audiooutput' && x.deviceId && !/^(default|communications)$/i.test(x.deviceId); });
        listEl.innerHTML = ''; listEl.hidden = false;
        var chain = Promise.resolve();
        outs.forEach(function (d, i) {
            var li = document.createElement('li');
            li.innerHTML = '<b>' + esc(d.label || (T.device_unknown + ' ' + (i + 1))) + '</b><span class="st-tag no">' + esc(F.scan_run) + '</span>';
            listEl.appendChild(li);
            chain = chain.then(function () {
                return ctx.setSinkId(d.deviceId).then(function () { return probeSide(stream, 'C'); }).then(function (r) {
                    var yes = !!(r && r.heard);
                    results.push({ id: d.deviceId, label: d.label, heard: yes });
                    li.setAttribute('data-heard', yes ? 'yes' : 'no');
                    li.innerHTML = '<b>' + esc(d.label || (T.device_unknown + ' ' + (i + 1))) + '</b><span class="st-tag ' + (yes ? 'yes' : 'no') + '">' + esc(yes ? F.scan_yes : F.scan_no) + '</span>'
                        + (yes ? '<button type="button" class="dk-btn dk-sm" data-use="' + esc(d.deviceId) + '">' + esc(F.scan_use) + '</button>' : '');
                }, function () { li.querySelector('.st-tag').textContent = F.scan_no; });
            });
        });
        return chain;
    }).then(function () {
        var hit = results.filter(function (r) { return r.heard; });
        var d = $('stChkMicD');
        if (d) d.innerHTML = esc(hit.length ? fill(F.scan_found, { name: hit[0].label || T.device_unknown }) : F.scan_nothing);
        stepState('stChkMic', hit.length ? 'ok' : 'bad');
        feat('st_scan', { n: results.length, heard: hit.length });
    }).catch(function (e) {
        stepState('stChkMic', 'bad', esc(F.mic_fail));
        feat('st_scan', { err: String((e && e.name) || 'error').slice(0, 40) });
    }).then(function () {
        try { if (ctx && ctx.setSinkId) ctx.setSinkId(before || '').catch(noop); } catch (e) { }
        if (stream) closeMic(stream);
        micBusy = false; btn.disabled = false;
        pill('ready', T.pill_ready);
    });
});
$('stScanList').addEventListener('click', function (e) {
    var b = e.target.closest('[data-use]');
    if (!b) return;
    var id = b.getAttribute('data-use'), sel = $('stDeviceSelect');
    if (sel && [].some.call(sel.options, function (o) { return o.value === id; })) { sel.value = id; sel.dispatchEvent(new Event('change')); }
    else { selectedDeviceId = id; if (ctx && ctx.setSinkId) ctx.setSinkId(id).catch(noop); }
    setMode('lr');
    startLr('quick');
});
qa('[data-prob]', $('stFix')).forEach(function (b) {
    if (!b.classList.contains('dk-option')) return;
    b.addEventListener('click', function () { openProb(b.getAttribute('data-prob')); });
});
function openProb(prob) {
    qa('.st-probs .dk-option', root).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-prob') === prob ? 'true' : 'false'); });
    qa('[data-prob-body]', root).forEach(function (x) { x.hidden = x.getAttribute('data-prob-body') !== prob; });
    if (prob === 'none') { deviceStep(); var low = $('stLowSnd'); if (low) low.hidden = S.lr.snd !== 'bass'; }
    feat('st_fix', { p: prob });
}

/* Переходы между режимами из итогов и подсказок («Измерить в режиме Баланс»). */
root.addEventListener('click', function (e) {
    /* «Проверить голосом» — из вердикта и из «Нет звука?», когда играл бас. */
    var tv = e.target.closest('[data-try-voice]');
    if (tv && root.contains(tv)) {
        var from = S.mode;
        pickSnd(VOICE_OK ? 'voice' : 't440');
        setMode('lr');
        startLr('quick');
        feat('st_try_voice', { from: from });
        return;
    }
    var g = e.target.closest('[data-goto]');
    if (!g || !root.contains(g)) return;
    var m = g.getAttribute('data-goto');
    setMode(m);
    if (m === 'freq' && g.getAttribute('data-fsub')) setFsub(g.getAttribute('data-fsub'));
    if (m === 'fix' && g.getAttribute('data-prob')) openProb(g.getAttribute('data-prob'));
});

/* ═══ РЕЖИМЫ ═════════════════════════════════════════════════════════════════ */
var DK = window.DeviceKit;
var $side = $('stSide');
function sndLabel() {
    var txt = '';
    if (S.mode === 'lr') txt = T.snd[S.lr.snd] || '';
    else if (S.mode === 'bal') txt = T.snd[S.bal.snd] || '';
    else if (S.mode === 'surr') txt = T.surr_snd[S.surr.snd] || '';
    else if (S.mode === 'freq') txt = '';
    setText($sndLbl, txt);
}
function setMode(m, opts) {
    if (!/^(lr|bal|surr|freq|fix)$/.test(m)) m = 'lr';
    var changed = S.mode !== m;
    if (changed) stopAll();
    S.mode = m;
    var apply = function () {
        root.setAttribute('data-mode', m);
        qa('.st-mode', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mode') === m ? 'true' : 'false'); });
        qa('[data-pane]', root).forEach(function (el) { el.hidden = el.getAttribute('data-pane') !== m; });
        qa('[data-result]', root).forEach(function (el) { el.hidden = el.getAttribute('data-result') !== m || !el.hasAttribute('data-has'); });
        $('stScreen').hidden = m === 'fix';
        /* Итог прошлого режима уходит, итог этого — остаётся, как был. */
        qa('[data-for]', $side).forEach(function (el) { el.hidden = (' ' + el.getAttribute('data-for') + ' ').indexOf(' ' + m + ' ') === -1; });
        var open = $side.querySelector('.dk-sec.is-open');
        if (open && open.hidden && DK) { var first = qa('.dk-sec', $side).filter(function (s) { return !s.hidden; })[0]; if (first) DK.openSection(first); }
        sndLabel();
        if (m === 'surr') { peekCtx(); capText(); }
        if (m === 'bal' && !S.bal.moved && S.bal.b1 == null) balStart();
        if (m === 'freq') { vizSize(); setFsub(S.freq.sub, true); }
        if (m === 'fix') deviceStep();
    };
    if (changed && !(opts && opts.instant) && window.__viewTransition) window.__viewTransition(apply); else apply();
    if (changed) {
        feat('st_mode', { m: m });
        try { if (window.__toolSettings) window.__toolSettings.save(SLUG, 'mode', m); } catch (e) { }
    }
}
qa('.st-mode', root).forEach(function (b) {
    b.addEventListener('click', function () { setMode(b.getAttribute('data-mode')); });
});

/* ── выход звука (общий примитив) ────────────────────────────────────────── */
var outputPicker = null;
if (window.AudioOutputPicker) {
    outputPicker = window.AudioOutputPicker.attach({
        wrap: '#stDeviceGroup', detect: '#stDeviceDetect', select: '#stDeviceSelect', refresh: '#stDeviceRefresh',
        slug: SLUG, locale: CFG.locale,
        strings: { 'default': T.device_default, unknown: T.device_unknown },
        apply: function (id) {
            selectedDeviceId = id;
            if (ctx && ctx.setSinkId) ctx.setSinkId(id).catch(noop);
            outLabel();
        },
        onPopulate: function () { outLabel(); }
    });
} else {
    var dg = $('stDeviceGroup'); if (dg) dg.hidden = true;
}

/* ═══ ФАЙЛЫ ДЛЯ ФЛЕШКИ (Премиум) ═════════════════════════════════════════════
   Те же проверки файлами — для магнитолы, телевизора, ресивера. Два шага:
   «Подготовить» (рендер, запись и упаковка в ZIP — __batchDeliver.packZip) →
   «Скачать ZIP · N МБ» отдаёт ГОТОВЫЙ архив первым вызовом нажатия. Упаковка
   при нажатии «Скачать» (deliver) сперва грузила помощников архива, и на
   медленной сети жест истекал раньше, чем файл был готов: браузер молча не
   скачивал. Генератор и писатели грузятся только здесь. */
var PK = T.pack || {};
var pack = { kind: 'stereo', fmt: 'mp3', busy: false, ready: null };
var $packGo = $('stPackGo'), $packLbl = $('stPackGoLbl'), $packNote = $('stPackNote');
/* Разметка приходит одной гостевой копией из кэша, тариф — позже снимком сессии
   (/api/session-bootstrap). Нажатие до снимка ждёт его, а не показывает
   Премиум-человеку предложение купить Премиум. */
function isPro() { try { return window.__isProNow ? !!window.__isProNow(false) : !!(DK && DK.isPro()); } catch (e) { return false; } }
function whenTier(ms) {
    return new Promise(function (res) {
        if (window.__BOOTSTRAP) return res();
        var done = false, go = function () { if (!done) { done = true; res(); } };
        document.addEventListener('tier-bootstrap:ready', go, { once: true });
        setTimeout(go, ms);
    });
}
function packKey() { return pack.kind + (pack.kind === 'stereo' ? '-' + pack.fmt : ''); }
function fmtMb(b) { return NF1.format(Math.max(0.1, b / 1048576)); }
function renderPack() {
    if (!$packGo) return;
    qa('[data-pack]', $side).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pack') === pack.kind ? 'true' : 'false'); });
    qa('[data-pack-fmt]', $side).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pack-fmt') === pack.fmt ? 'true' : 'false'); });
    var fmtRow = $('stPackFmt'); if (fmtRow) fmtRow.hidden = pack.kind !== 'stereo';
    var have = pack.ready && pack.ready.key === packKey();
    if (!pack.busy) setText($packLbl, have ? fill(PK.download, { mb: fmtMb(pack.ready.bytes) }) : PK.prepare);
    $packGo.classList.toggle('dk-go', !!have);
    var sum = $('stSumPack');
    if (sum) setText(sum, (pack.kind === 'stereo' ? PK.stereo + ' · ' + pack.fmt.toUpperCase() : (pack.kind === '51' ? '5.1' : '7.1') + ' · WAV'));
}
function packUpsell() {
    var box = $side && $side.querySelector('.st-offer[data-offer="pack"]');
    if (box) {
        box.hidden = false;
        box.innerHTML = '<div class="dk-offer-t">' + (window.DeviceKit && DK.icon ? DK.icon('star') : '') + '<span>' + esc(fill(PK.pro_title, { plan: CFG.planName || 'Premium' })) + '</span></div>' +
            '<p>' + esc(PK.pro_body) + '</p>' +
            '<div class="dk-row"><a class="dk-btn dk-primary dk-sm" href="' + esc(CFG.proUrl || '#') + '">' + esc(fill(PK.pro_cta, { plan: CFG.planName || 'Premium' })) + '</a></div>';
        var a = box.querySelector('a');
        if (a) a.addEventListener('click', function () { funnel('perk_click', { what: 'pack' }); });
    }
    funnel('perk_upsell', { what: 'pack' });
}
function renderPackPro() {
    var pro = isPro();
    qa('[data-pro-tag]', $side).forEach(function (el) { el.hidden = pro; });
    if (pro) qa('.st-offer', $side).forEach(function (el) { el.hidden = true; });
}
var packLoad = null;
/* Генератор сам подгрузит свои писатели (WAV / MP3) — здесь только он и архив. */
function loadPack() {
    var bd = window.__ensureBatchDeliver ? window.__ensureBatchDeliver() : Promise.reject(new Error('no_batch'));
    var s = window.SpeakerTestPack ? Promise.resolve() : window.__loadScriptsOnce([CFG.pack.gen], 'speaker-test-pack');
    return Promise.all([s, bd]).then(function () {
        if (!window.SpeakerTestPack || !window.__batchDeliver) throw new Error('pack_missing');
    });
}
function packVoice(kind) {
    if (!VOICE_OK || !window.SpeakerTestPack) return Promise.resolve({});
    peekCtx();
    if (!ctx) return Promise.resolve({});
    return voice(window.SpeakerTestPack.voiceKeys(kind)).catch(function (e) { voiceFailed(e); return {}; });
}
function preparePack() {
    var key = packKey(), kind = pack.kind, fmt = pack.fmt, t0 = Date.now();
    pack.busy = true; $packGo.disabled = true;
    setText($packLbl, fill(PK.making, { pct: 0 }));
    setText($packNote, '');
    loadPack().then(function () {
        return packVoice(kind);
    }).then(function (v) {
        return window.SpeakerTestPack.build(kind, {
            voice: v, format: fmt, strings: PK.readme || {},
            onProgress: function (f) { setText($packLbl, fill(PK.making, { pct: Math.round(f * 100) })); }
        });
    }).then(function (r) {
        return window.__batchDeliver.packZip(r.items).then(function (zip) {
            pack.ready = { key: key, kind: kind, fmt: fmt, zip: zip, bytes: zip.size, n: r.items.length };
            setText($packNote, PK.ready);
            say(PK.ready);
            feat('st_pack_ready', { kind: kind, fmt: kind === 'stereo' ? fmt : 'wav', mb: Math.round(zip.size / 1048576), ms: Date.now() - t0 });
        });
    }).catch(function (e) {
        pack.ready = null;
        setText($packNote, PK.fail);
        if (window.__handleError) try { window.__handleError(e, 'st_pack_build', { say: PK.fail }); } catch (x) { }
        feat('st_pack_fail', { kind: kind, err: String((e && (e.name || e.message)) || 'error').slice(0, 40) });
    }).then(function () {
        pack.busy = false; $packGo.disabled = false;
        renderPack();
    });
}
function downloadPack() {
    var r = pack.ready, name = 'speaker-test-' + (r.kind === 'stereo' ? 'stereo-' + r.fmt : (r.kind === '51' ? '5.1' : '7.1')) + '.zip';
    // Первый вызов нажатия — выдача: позже жест истекает, и браузер молча откажет.
    Promise.resolve(window.__downloadFile(r.zip, name)).then(function (ok) {
        setText($packNote, ok !== false ? PK.done : PK.fail);
        feat('st_pack_download', { kind: r.kind, ok: ok !== false ? 1 : 0, n: r.n });
    }, function (e) {
        setText($packNote, PK.fail);
        if (window.__handleError) try { window.__handleError(e, 'st_pack_deliver', { say: PK.fail }); } catch (x) { }
    });
}
if ($packGo) {
    qa('[data-pack]', $side).forEach(function (b) {
        b.addEventListener('click', function () {
            if (pack.busy) return;
            pack.kind = b.getAttribute('data-pack');
            try { if (window.__toolSettings) window.__toolSettings.save(SLUG, 'pack_kind', pack.kind); } catch (e) { }
            renderPack();
        });
    });
    qa('[data-pack-fmt]', $side).forEach(function (b) {
        b.addEventListener('click', function () {
            if (pack.busy) return;
            pack.fmt = b.getAttribute('data-pack-fmt') === 'wav' ? 'wav' : 'mp3';
            try { if (window.__toolSettings) window.__toolSettings.save(SLUG, 'pack_fmt', pack.fmt); } catch (e) { }
            renderPack();
        });
    });
    $packGo.addEventListener('click', function () {
        if (pack.busy) return;
        if (pack.ready && pack.ready.key === packKey()) { downloadPack(); return; }
        if (isPro()) { preparePack(); return; }
        if (window.__BOOTSTRAP) { packUpsell(); return; }
        pack.busy = true; $packGo.disabled = true;
        whenTier(4000).then(function () {
            pack.busy = false; $packGo.disabled = false;
            if (isPro()) preparePack(); else packUpsell();
        });
    });
    try {
        if (window.__toolSettings && window.__toolSettings.load) {
            var k0 = window.__toolSettings.load(SLUG, 'pack_kind'), f0 = window.__toolSettings.load(SLUG, 'pack_fmt');
            if (/^(stereo|51|71)$/.test(k0 || '')) pack.kind = k0;
            if (f0 === 'wav' || f0 === 'mp3') pack.fmt = f0;
        }
    } catch (e) { }
    renderPack();
    renderPackPro();
    if (DK && DK.onTier) try { DK.onTier(renderPackPro); } catch (e) { }
}

/* ── клавиши: L / R / B — каналы, пробел — быстрая проверка или стоп ─────── */
document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey) return;
    if (window.__keyOwnedByFocus && window.__keyOwnedByFocus(e)) return;
    var t = e.target;
    if (t && t.closest && !t.closest('#stConsole') && t !== document.body) return;
    var k = (e.key || '').toLowerCase();
    if (S.mode === 'lr' && (k === 'l' || k === 'r' || k === 'b')) {
        e.preventDefault();
        var tile = root.querySelector('.st-tile[data-ch="' + (k === 'b' ? 'C' : k.toUpperCase()) + '"]');
        if (tile) tile.click();
        feat('hotkey', { k: k });
    } else if (k === ' ' && (S.mode === 'lr' || cur)) {
        e.preventDefault();
        if (cur) stopAll(); else $('stQuick').click();
    }
});

document.addEventListener('visibilitychange', function () { if (!document.hidden && cur) { meterOn(); if (S.mode === 'freq') vizOn(); } });
window.addEventListener('pagehide', function () { stopAll(); });

/* ── старт ───────────────────────────────────────────────────────────────── */
if (!window.AudioContext && !window.webkitAudioContext) {
    qa('button', root).forEach(function (b) { if (!b.closest('#stFix')) b.disabled = true; });
    status(T.no_web_audio);
}
if (DK && $side) {
    try { DK.accordion($side, { slug: SLUG }); } catch (e) { }
}
sndLabel();
setMode('lr', { instant: true });

/* Нажатие, сделанное до этого скрипта (медленная сеть), не теряется. */
if (EA) {
    try {
        window.__earlyAction.claim(EA_KEY, function (act) {
            if (!act) return;
            if (act === 'quick') $('stQuick').click();
            else if (act.indexOf('ch-') === 0) { var tl = root.querySelector('.st-tile[data-ch="' + act.slice(3) + '"]'); if (tl) tl.click(); }
            else if (act.indexOf('mode-') === 0) setMode(act.slice(5));
        });
    } catch (e) { }
}
})();
